var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;

// Font Resizer-------------------Start
function fontResizer() {
  var perc = parseInt(sw) / 118.9375;
  document.body.style.fontSize = perc + "px";
}



// Loader-------------------Start
function pageLoader() {
  setTimeout(function () {
    document.querySelector("html").classList.remove("loadjs");
  }, 800);
}

// // Navigation slide Active on a mobile
// if (document.querySelector("#toggle")) {
//   let toggleMenu = document.querySelector("#toggle");
//   let htmlEl = document.querySelector("html");

//   toggleMenu.addEventListener("click", (event) => {
//     console.log("this", event);
//     let _this = event.target;
//     _this.classList.toggle("active");
//     document.querySelector(".navigation").classList.toggle("open");
//     htmlEl.classList.toggle("overflow-hidden");
//   });
// }


// Navigation slide Active on a mobile
if (document.querySelector("#toggle")) {
  let toggleMenu = document.querySelector("#toggle");
  let htmlEl = document.querySelector("html");

  toggleMenu.addEventListener("click", (event) => {
    console.log("this", event);
    let _this = event.target;
    _this.classList.toggle("active");
    document.querySelector(".navigation").classList.toggle("open");
    htmlEl.classList.toggle("overflow-hidden");
    if (document.querySelector(".navigation").classList.contains('open')) { } else {
      document.querySelectorAll(".mobileToggle").forEach(item => {
        item.classList.remove('open--menu');
        item.nextElementSibling.classList.remove('openMegaMenu')
      })

    }
    // document.querySelector(".inner-menu").classList.toggle("openMegaMenu");

  });
}



// Landscape Mode off
function landscapeModeOff() {
  if (sh < 450 && sw > 480 && sw < 820) {
    document.getElementById("portrait-warnning").style.display = "flex";
  } else {
    document.getElementById("portrait-warnning").style.display = "none";
  }
}

// Sticky Header----------------Start
function stickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

// Window on Load-----------------Start
window.onload = function () {
  pageLoader();
  if (sw > 1199) {
    fontResizer();
  }
  // SVG Convert Code
  let svgs = document.querySelectorAll("img.svg-convert");
  svgs.forEach((el) => {
    const imgID = el.getAttribute("id");
    const imgClass = el.getAttribute("class");
    const imgURL = el.getAttribute("src");

    fetch(imgURL)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, "text/html");
        let svg = xmlDoc.querySelector("svg");
        if (typeof imgID !== "undefined") {
          svg.setAttribute("id", imgID);
        }

        if (typeof imgClass !== "undefined") {
          svg.setAttribute("class", imgClass + " svg-converted");
        }

        svg.removeAttribute("xmlns:a");

        el.parentNode.replaceChild(svg, el);
      });
  });

  // if (window.location.hash) {
  //   var urled = (window.location.hash)
  //   var elementid = document.querySelector(urled);
  //   setTimeout(function () {
  //     window.scrollTo({
  //       top: elementid.offsetTop,
  //       behavior: 'smooth'
  //     });
  //   }, 1200);
  //   setTimeout(function () {
  //     var headerHeight = header.offsetHeight;
  //     window.scrollTo({
  //       top: elementid.offsetTop - headerHeight,
  //       behavior: 'smooth'
  //     });
  //   }, 1200);
  // } else {
  // }

  if (window.location.hash == "#leadershipSec") {
    const media = window.matchMedia("(max-width: 576px)")
    if (media.matches) {
      document.documentElement.style.scrollPaddingTop = '13.75em'
      console.log("yes")
    }

    else {
      document.documentElement.style.scrollPaddingTop = '18em'
    }
  }
};

// Window On Resize-----------------Start
window.addEventListener("resize", (event) => {
  sw = window.innerWidth;
  sh = window.innerHeight;
  landscapeModeOff();
  if (sw > 1025) {
    if (sw < 1400 && sw > 1300 && sh > 900) { } else {
      fontResizer();
    }
  }
});

// Window On Scroll-----------------Start
window.addEventListener("scroll", (event) => {
  stickyHeader();
});

// if (document.querySelector(".journey__slider")) {
//   var journey__slider = new Swiper(".journey__slider", {
//     effect: "cards",
//     grabCursor: true,
//     cardsEffect: {
//       // perSlideOffset: 0,
//       rotate: false,
//       // perSlideOffset: 20,
//       slideShadows: false,
//       loop: true,
//       loopPreventsSliding: true,
//       loopedSlides: 10,
//     },
//   });
// }


// function setNavigation() {
//   let current_location = location.pathname.split("/")[1];
//   let current_location_ar = location.pathname.split("/ar/")[1];
//   let lang = document.documentElement.getAttribute("lang")

//   if (current_location === "") return;
//   let menu_items = document.querySelector("header").getElementsByTagName("a");
//   if (lang == "en") {
//     for (let i = 0, len = menu_items.length; i < len; i++) {
//       if (menu_items[i].getAttribute("href").indexOf(current_location) !== -1) {
//         menu_items[i].classList.add("active");
//       }
//     }
//   }

//   if (lang == "ar") {
//     for (let i = 0, len = menu_items.length; i < len; i++) {
//       if (menu_items[i].getAttribute("href").indexOf(current_location_ar) !== -1) {
//         menu_items[i].classList.add("active");
//       }
//     }
//   }
// }
// setNavigation();


if (document.querySelector(".leadership__slider")) {
  var leadership__slider = new Swiper(".leadership__slider", {
    slidesPerView: 1,
    allowTouchMove: true,
    loop: false,
    spaceBetween: 15,
    autoplay: {
      enable: true,
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1199: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

}
// About Cards Animation
// if (document.querySelector(".journey")) {
//   const startAnimation = () => {
//     const allCards = document.querySelectorAll(".card");
//     const topCard = document.querySelector(".card-1");
//     topCard.classList.add("shuffle");
//     topCard.addEventListener("animationstart", reorderCardsWhenAnimationFinished);
//   };

//   const reorderCardsWhenAnimationFinished = (e) => {
//     if (e.animationName === "move-left") {
//       const allCards = document.querySelectorAll(".card");
//       moveFirstCardToBack(allCards);
//     }
//   };

//   const finishAnimation = () => {
//     document.removeEventListener(
//       "animationend",
//       reorderCardsWhenAnimationFinished
//     );
//     const allCards = document.querySelectorAll(".card");
//     Array.from(allCards).map((card) => card.classList.remove("shuffle"));
//     startAnimation();
//   };

//   const moveFirstCardToBack = (cards) => {
//     Array.from(cards).map((card, index) => {
//       const cardClass = Object.values(card.classList).find(
//         (className) => className !== "card" && className !== "shuffle"
//       );
//       const cardNumber = parseInt(cardClass.split("-")[1], 10);
//       const nextCardNumber = cardNumber === 1 ? cards.length : cardNumber - 1;
//       card.classList.remove(cardClass);
//       card.classList.add("card-" + nextCardNumber);
//     });
//     finishAnimation();
//   };
//   document.addEventListener("DOMContentLoaded", () => {
//     startAnimation();
//   });

//   function journeyWidth() {
//     const root_theme = document.querySelector(":root");
//     const cardParent = document.querySelector(".journey__rightsec");
//     const cardParentWidth = cardParent.offsetWidth;
//     console.log(cardParentWidth);
//     root_theme.style.setProperty("--card-width", cardParentWidth + "px");
//   };
//   journeyWidth();
//   window.addEventListener("resize", (event) => {
//     journeyWidth();
//   });
// }



// if (document.querySelector(".phone-group")) {
//   let input = document.getElementById("phone");
//   var iti = intlTelInput(input, {
//     initialCountry: "ae",
//     separateDialCode: true,
//   });
// }



const inViewport = (elem) => {
  let allElements = document.getElementsByTagName(elem);
  let windowHeight = window.innerHeight - 500;
  const elems = () => {
    for (let i = 0; i < allElements.length; i++) { //  loop through the sections
      let viewportOffset = allElements[i].getBoundingClientRect(); //  returns the size of an element and its position relative to the viewport
      let top = viewportOffset.top; //  get the offset top
      if (top < windowHeight) { //  if the top offset is less than the window height
        allElements[i].classList.add('in-viewport'); //  add the class
      } else {
        allElements[i].classList.remove('in-viewport'); //  remove the class
      }
    }
  }
  elems();
  window.addEventListener('scroll', elems);
}

inViewport('section'); //  run the function on all section elements

let toggleFooter = document.querySelectorAll(".toggle-btn");


if (sw < 767) {
  if (toggleFooter.length > 0) {
    for (let i = 0; i < toggleFooter.length; i++) {
      const setActive = (el) => {
        let bol = el.classList.contains('opened');
        [...el.parentElement.parentElement.children].forEach((sib) => {
          sib.children[0].classList.remove("opened");
          let panel = sib.children[1];
          panel.style.maxHeight = null;
          panel.classList.remove("opened")
        });
        if (bol == false) {
          el.classList.add("opened");
          let panel = el.nextElementSibling;
          panel.classList.add("opened")
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      };
      let spans = [...toggleFooter[i].querySelectorAll(".toggle-btn > p")];
      spans.forEach((el) => el.addEventListener("click", (e) => setActive(el)));
    }
  }
}


if (sw < 1200) {
  let mobileToggle = document.querySelector(".mobileToggle,.has-child-menu");

  mobileToggle.addEventListener("click", (event) => {
    document.querySelector(".mobileToggle").classList.toggle("open--menu");
    document.querySelector(".inner-menu").classList.toggle("openMegaMenu");
  });
}



// function functionforscroll(id) {
//     var getMeTo = document.getElementById(id);
//     const yOffset = -80;
//     const y = getMeTo.getBoundingClientRect().top + window.pageYOffset + yOffset;
//     setTimeout(function () {
//         window.scrollTo({
//             top: y,
//             behavior: 'smooth'
//         });
//         // getMeTo.scrollIntoView();
//     }, 500)
//     var uri = window.location.toString();
//     console.log(uri)
//     if (uri.indexOf("#") > 0) {
//         var clean_uri = uri.substring(0, uri.indexOf("#"));
//         window.history.replaceState({}, document.title, clean_uri);
//     }
// }

// functionforscroll();

// if (document.querySelector(".about")) {

//   document.querySelector('.designation-card').addEventListener("click", (event) => {
//     document.querySelector(".designation-card-wrapper").classList.add("open");
//     document.querySelector("body").classList.add("overflow-hidden");

//   });
// }



// document.querySelectorAll(".designation-card").forEach(function (card) {

//   card.addEventListener('click', function (e) {
//     let attr = this.getAttribute("data-card");
//     document.querySelector(".designation-card-wrapper").classList.add("open");
//     let cardi = document.querySelector(`.designation-card-wrapper .designation-card[data-card="${attr}"]`);
//     cardi.classList.add('open');
//     document.querySelector("html").classList.add("overflow-hidden");

//   });
// });

// document.querySelector(".pop-up-close").addEventListener("click", (e) => {
//   document.querySelector(".designation-card-wrapper").classList.remove("open");
//   document.querySelector("html").classList.remove("overflow-hidden");
//   document.querySelectorAll(".designation-card-wrapper .designation-card").forEach(function (e) {
//     e.classList.remove('open');
//   })
// })

// document.querySelector(".designation-card-gradient").addEventListener("click", (event) => {
//   document.querySelector(".designation-card-wrapper").classList.remove("open");
//   document.querySelector("html").classList.remove("overflow-hidden");
//   document.querySelectorAll(".designation-card-wrapper .designation-card").forEach(function (e) {
//     e.classList.remove('open');
//   })
// })